import styles from './ClaimButton.module.css';

interface Props {
    claimedByUserId: number | null;
    claimedByName: string | null;
    meId: number;
    busy?: boolean;
    onClaim: () => void;
    onRelease: () => void;
}

/**
 * Shared-queue claim control. Unclaimed → "Claim"; held by me → "Release"; held by
 * someone else → "Claimed by X" (read-only). The claim is enforced server-side, so
 * editing controls elsewhere key off `claimedByUserId === meId`.
 */
export function ClaimButton({
    claimedByUserId,
    claimedByName,
    meId,
    busy,
    onClaim,
    onRelease,
}: Props) {
    if (claimedByUserId === null) {
        return (
            <button className="primary" onClick={onClaim} disabled={busy}>
                Claim
            </button>
        );
    }
    if (claimedByUserId === meId) {
        return (
            <button onClick={onRelease} disabled={busy} title="You hold this claim">
                Release
            </button>
        );
    }
    return (
        <span
            className={styles.heldBy}
            title={`Claimed by ${claimedByName ?? 'another coordinator'}`}
        >
            🔒 {claimedByName ?? 'Claimed'}
        </span>
    );
}
